module.exports = __webpack_public_path__ + "img/1361403-03-3.12c92068.png";